export default (url: string | undefined) => {
  return !!url?.match(/^https?:\/\//);
};
